// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
Vue.use(Vant);
let base_url = '/api'
axios.defaults.baseURL = base_url
Vue.prototype.$http = axios
Vue.prototype.$baseURL = base_url
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  window.localStorage.setItem('f_open_id', 'eryi13')
  next();
  // if (getCookie('openid')) {
  //   window.localStorage.setItem('f_open_id', getCookie('openid'))
  //   next();
  //
  // } else {
  //   window.location.href = "http://weixin.evledm.com/fte-game/web/api/open-id?url=http://weixin.evledm.com/winter-audio"
  // }
})


//获取cookie
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return false;
}

function GetQueryString(name) {

  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

  var r = window.location.search.substr(1).match(reg);

  if (r != null) return unescape(r[2]);
  return null;

}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js